import React, { Component } from "react";
import { connect } from "react-redux";
import {
  earlyVotingWatchOn,
  earlyVotingWatchOff
} from "../../actions/earlyVotingActions";
import {
  finalVotingWatchOn,
  finalVotingWatchOff
} from "../../actions/finalVotingActions";
import _ from "lodash";

import ClassCodes from "../classCodes";
import Agenda from "./Agenda";
import List from "./List";
import VotingOpen from "../debate/VotingOpen";

class FinalVoting extends Component {
  componentDidMount() {
    this.props.earlyVotingWatchOn();
    this.props.finalVotingWatchOn();
  }

  componentWillUnmount() {
    this.props.earlyVotingWatchOff();
    this.props.finalVotingWatchOff();
  }

  render() {
    const { cCode } = this.props.location.params || {};
    const { users } = this.props;
    return (
      <>
        <ClassCodes />
        {cCode && !_.isEmpty(users) && (
          <>
            <Agenda />
            <List />
            <VotingOpen votingType={"finalVoting"} />
          </>
        )}
      </>
    );
  }
}

const mapStateToProps = state => ({
  users: state.users,
  location: state.location
});

export default connect(
  mapStateToProps,
  {
    earlyVotingWatchOn,
    earlyVotingWatchOff,
    finalVotingWatchOn,
    finalVotingWatchOff
  }
)(FinalVoting);
